








































import tooltip from "./tooltip.vue";
import ripple from "./ripple.vue";
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import moment,{ weekdays, Moment } from "moment";

@Component({
    components: {
        ripple,
        tooltip
    }
})
export default class ChatBubble extends Vue {
    @Prop({}) mine:string;
    @Prop({}) sameAsPrev:boolean;
    @Prop({}) sameAsNext:boolean;
    @Prop({}) properties:{
        fullName: string,
        userID:string,
        date:Date,
        text?:string,
        image?:string,
        seen:boolean,
    }

    get realName() {return this.properties.fullName;};
    realDate:string = null;

    mounted(){
        this.getRealDate()
    }

    @Watch('properties.date')
    getRealDate(){
        let momentVar = moment(this.properties.date);

        if(momentVar.isSame(new Date(), 'hour')){
            this.realDate = momentVar.fromNow();
        }else{
            this.realDate = momentVar.fromNow() + ' - ' + momentVar.format('h:mm a')
        }
    }

}

